import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/stablr.webp';
import screenshot_target from '../../../images/letterfunnel/gijsopdeweegh.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Gijs op de Weegh"
      firstname="Gijs"
      companyname="StablR"
      competition="Circle en Mimo"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/gijsopdeweegh.js